<template>
  <div>
    <h1>Changelog</h1>
    <div>
      <ul>
        <li>Coffee</li>
        <li>Tea</li>
        <li>Milk</li>
      </ul>
    </div>
  </div>
</template>

<script setup>
  export default {
    name: "Changelog",
    mounted() {
      document.title = "MyHD - Changelog"; // Set the browser tab title
    },
  };
</script>

<style scoped lang="css">

</style>
